import { Navigate, Outlet, useLocation } from 'react-router'
import type { Permission } from '@sonder/shared'
import { useAuth } from './AuthProvider'

function Loading() {
  return (
    <div className="grid min-h-dvh place-items-center" role="status" aria-live="polite">
      <span className="text-eyebrow uppercase tracking-eyebrow text-dim">Loading…</span>
    </div>
  )
}

export function RequireAuth() {
  const { loading, user } = useAuth()
  const loc = useLocation()
  if (loading) return <Loading />
  if (!user) return <Navigate to="/sign-in" replace state={{ from: loc.pathname + loc.search }} />
  return <Outlet />
}

export function RequireStaff() {
  const { loading, user, role } = useAuth()
  if (loading) return <Loading />
  if (!user) return <Navigate to="/sign-in" replace />
  if (role !== 'staff') return <Navigate to="/" replace />
  return <Outlet />
}

/** Inside the staff console: send people whose role lacks the permission back to the client list. */
export function RequirePermission({ permission, admin }: { permission?: Permission; admin?: boolean }) {
  const { staff, can } = useAuth()
  if (admin ? !staff?.admin : permission && !can(permission)) return <Navigate to="/staff" replace />
  return <Outlet />
}
